module.exports = __webpack_public_path__ + "img/181.e6e41c7d.jpg";